import { render, staticRenderFns } from "./AIDescriptionPreview.vue?vue&type=template&id=1bca3bdc&scoped=true"
import script from "./AIDescriptionPreview.vue?vue&type=script&lang=js"
export * from "./AIDescriptionPreview.vue?vue&type=script&lang=js"
import style0 from "./AIDescriptionPreview.vue?vue&type=style&index=0&id=1bca3bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca3bdc",
  null
  
)

export default component.exports